import { render, staticRenderFns } from "./budget-proposal-modal.vue?vue&type=template&id=44dc6b88&"
import script from "./budget-proposal-modal.vue?vue&type=script&lang=js&"
export * from "./budget-proposal-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports